import React, { Fragment } from 'react';
import { styled } from '@mui/material/styles';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import CancelIcon from '@mui/icons-material/Cancel';


const PREFIX = 'DoubleDropdownItem';

const classes = {
    formControl: `${PREFIX}-formControl`,
    selectEmpty: `${PREFIX}-selectEmpty`,
    filterTextPrimary: `${PREFIX}-filterTextPrimary`,
    filterTextSecondary: `${PREFIX}-filterTextSecondary`
};

const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.formControl}`]: {
        width: '95%',
    },

    [`& .${classes.filterTextPrimary}`]: {
        fontSize: theme.typography.pxToRem(14), /*fontsize of the menu and selected element*/
    },

    [`& .${classes.filterTextSecondary}`]: {
        fontSize: theme.typography.pxToRem(13), /*aparently not used*/
    },
}));

function DoubleDropdown(props) {

    const {
        handleChangeInitPeriod,
        handleChangeEndPeriod,
        addNewScheduleSelector,
        removeScheduleSelector,
        initSchedule,
        endSchedule,
        arrayId,
        data, 
        required,
        showDelete
    } = props;

    const scheduleItemArray = []
    for (var i = 0; i < data.length; i++) {
        scheduleItemArray.push(
            <MenuItem key = {data[i].id} value={{dataValue: data[i].name, arrayId: arrayId}}>
                <Typography className={classes.filterTextPrimary}>
                {data[i].name}
                </Typography>
            </MenuItem>
        )
    }


    var labelTextinit = "Inicio";
    var labelTextend = "Termino";
    if (required) {
        labelTextinit = <Box color="error.main"> {labelTextinit} *</Box>;
        labelTextend = <Box color="error.main"> {labelTextend} *</Box>;
    }

    return (
        <div>
        <Typography component={'div'} className={classes.filterTextPrimary}>
            <div style={{ display: "flex" }}>
                Escoge un rango de horarios
            </div>
        </Typography>
        <Grid container justifyContent="left" alignItems="center" spacing={0} >
            {
                showDelete == true ?
                <Grid item xs={1.3}>
                    <IconButton  sx={{padding: 0}} onClick={() => removeScheduleSelector(arrayId)} variant="text">
                        <CancelIcon color='error'/>
                    </IconButton >
                </Grid>
                :
                null
            }
            <Grid item xs={4.6}>
                <FormControl variant="standard" className={classes.formControl}>
                    <Select value={{dataValue: initSchedule, arrayId: arrayId}} renderValue={(value) => (value.dataValue ? value.dataValue : labelTextinit)} onChange={handleChangeInitPeriod} displayEmpty>
                        <MenuItem value='' disabled>
                            <Typography component={'div'} className={classes.filterTextPrimary}>
                                {labelTextinit}
                            </Typography>
                        </MenuItem>
                        {scheduleItemArray}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={4.6}>
                <FormControl variant="standard" className={classes.formControl}>
                    <Select value={{dataValue: endSchedule, arrayId: arrayId}} renderValue={(value) => (value.dataValue ? value.dataValue : labelTextend)}  onChange={handleChangeEndPeriod} displayEmpty>
                        <MenuItem value='' disabled>
                            <Typography component={'div'} className={classes.filterTextPrimary}>
                                {labelTextend}
                            </Typography>
                        </MenuItem>
                        {scheduleItemArray}
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={1}>
                <IconButton  onClick={addNewScheduleSelector} variant="text">
                    <AddCircleOutlineIcon color='primary'/>
                </IconButton >
            </Grid>
        </Grid>
        </div>
    )
}

function DoubleDropdownItem(props) {
    return (
        <Root>
            <ListItem>
                <ListItemText primary={
                    <DoubleDropdown
                        {...props}
                    />
                } />
            </ListItem>
            <Divider />
        </Root>
    );
}

export default DoubleDropdownItem;